function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-user-plus"
}, "User Plus Icon-");

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 34.77,
  cy: 32.95,
  r: 7.5
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51,33v10.5a1.5,1.5,0,0,0,3,0V33a1.5,1.5,0,1,0-3,0Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.47,36.7H46.88a1.5,1.5,0,0,0,0,3H58.47a1.5,1.5,0,0,0,0-3Z"
});

var SvgIconUserPlus = function SvgIconUserPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-user-plus",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-user-plus"
  }, title) : null, React.createElement("path", {
    d: "M50.5,54.55a16,16,0,0,0-30.47,0",
    style: {
      fillRule: "evenodd"
    }
  }), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconUserPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-user-plus.0c9a7a1a.svg";
export { ForwardRef as ReactComponent };